import { useCurrentAccount } from "PFCore/hooks/queries/account/use_current_account";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import i18n from "PFCore/i18n";
import { useEffect } from "react";

export const changeLanguage = (locale?: string) => {
  if (locale) {
    i18n.changeLanguage(locale);
  }
};

export const useChangeLanguageForAccount = () => {
  const { data: currentAccount } = useCurrentAccount();

  useEffect(() => {
    changeLanguage(currentAccount.customization?.locale);
  }, [currentAccount.id]);
};

export const useChangeLanguageForCurrentProfile = () => {
  const { data: currentProfile } = useCurrentProfile();

  useEffect(() => {
    changeLanguage(currentProfile.locale);
  }, [currentProfile?.locale]);
};
